export default __webpack_public_path__ + "images/9fdaeb343c23b74d0a96721d51ce1c33-medicine_small.webp";